import React from 'react';
import LitImage from './images/LitImage';
import LitStructuredText from './generic/LitStructuredText';
const communityReview = ({
  communityReviewHeader,
  communityReview,
  communityReviewerTitle,
  communityReviewImage,
  buttonText,
  buttonPath,
}) => {
  return (
    <div className="community-review-container">
      <div className="community-review-inner">
        <div className="community-review-content">
          <LitStructuredText data={communityReviewHeader} basic />
          <figure>
            <blockquote>
              <LitStructuredText data={communityReview} />
            </blockquote>
            <figcaption>
              <LitStructuredText data={communityReviewerTitle} />
            </figcaption>
          </figure>
          <a href={buttonPath} target="_blank" className="button">
            {buttonText}
          </a>
        </div>
        <div className="community-review-image">
          <LitImage image={communityReviewImage} alt="man with thumbs up" />
        </div>
      </div>
    </div>
  );
};

export default communityReview;
